module.exports = __webpack_public_path__ + "img/1.79b6a3c6.jpg";